import getInfoObject from "@/helpers/get-info-object";

export default function getRequestData(payload, portfolioElement) {
    return JSON.stringify(getInfoObject(payload, portfolioElement));
}